var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcome220K(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_558_1661)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 60,
    height: 60,
    rx: 12,
    fill: "url(#paint0_linear_558_1661)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_558_1661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 8.28472V52.7153C11 54.8052 12.7403 56.4979 14.8846 56.4979V4.5C12.7403 4.5 11 6.19479 11 8.28472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1271 54.1951V6.80312C18.1271 5.53264 19.1872 4.5 20.4939 4.5H23.0544V25.8028C22.2168 26.5455 21.507 27.3323 20.9336 28.0462C20.5413 28.5358 20.2142 28.9885 19.9561 29.3705C19.802 29.5976 19.672 29.799 19.5677 29.9667C19.3524 30.3118 19.352 30.6865 19.5674 31.0319C19.6717 31.1993 19.8016 31.4014 19.9561 31.6295C20.2142 32.0115 20.5413 32.4642 20.9336 32.9538C21.2863 33.3931 21.6903 33.8615 22.1456 34.3278C22.4297 34.6194 22.733 34.9111 23.0544 35.1951V56.4979H20.4939C19.1872 56.4979 18.1271 55.4674 18.1271 54.1951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2973 23.492V4.5H26.7006V23.492C27.7136 23.0892 28.8175 22.8455 30 22.8455C31.1825 22.8455 32.2842 23.0892 33.2973 23.492Z",
    fill: "url(#paint1_linear_558_1661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7006 37.508V56.4979H33.2973V37.508C32.2842 37.9108 31.1807 38.1545 30 38.1545C28.8193 38.1545 27.7158 37.9108 26.7006 37.508Z",
    fill: "url(#paint2_linear_558_1661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9438 4.5H39.5061C40.8107 4.5 41.8711 5.53264 41.8711 6.80312V54.1951C41.8711 55.4674 40.8107 56.4979 39.5061 56.4979H36.9438V35.199C37.7793 34.4562 38.4908 33.6694 39.0643 32.9576C39.6912 32.1753 40.1532 31.4816 40.433 31.0323C40.648 30.6865 40.6476 30.3118 40.4323 29.9663C40.1525 29.5174 39.6908 28.824 39.0643 28.0424C38.4908 27.3285 37.7793 26.5417 36.9438 25.801V4.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1154 4.5V56.5C47.2615 56.5 49 54.8052 49 52.7174V8.28472C49 6.19479 47.2615 4.5 45.1154 4.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7006 28.6795C27.148 26.2826 28.4569 24.5476 30 24.5476C31.5413 24.5476 32.8481 26.2788 33.2973 28.6701C33.4059 29.2458 33.465 29.8601 33.465 30.499C33.465 31.1382 33.4059 31.7524 33.2973 32.3299C32.8481 34.7212 31.5431 36.4503 30 36.4503C28.4569 36.4503 27.148 34.7156 26.7006 32.3205C26.5923 31.7465 26.535 31.1344 26.535 30.499C26.535 29.8639 26.5923 29.2535 26.7006 28.6795Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 59,
    height: 59,
    rx: 11.5,
    stroke: "url(#paint3_linear_558_1661)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_558_1661",
    x: 8,
    y: 3.5,
    width: 44,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_558_1661"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_558_1661",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_558_1661",
    x1: 30,
    y1: 0.5,
    x2: 30,
    y2: 60.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BA3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1055FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_558_1661",
    x1: 15.0096,
    y1: 3.65556,
    x2: 45.472,
    y2: 57.1597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA281B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#FFE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_558_1661",
    x1: 15.0096,
    y1: 3.65556,
    x2: 45.472,
    y2: 57.1597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA281B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#FFE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_558_1661",
    x1: 30,
    y1: 0.5,
    x2: 30,
    y2: 60.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_558_1661"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 60,
    height: 60,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome220K);
export default __webpack_public_path__ + "static/media/welcome-220k.bf3d358a501a0707204abb80f4bd7b37.svg";
export { ForwardRef as ReactComponent };